<template>
  <div class="video_open">
    <headd :mobile_title="mobile_title"></headd>
    <div>
    <video
      controls
      id="myVideo"
      :src="video_url"
      autoplay="autoplay"
      show-fullscreen-btn="true"
      :poster="img_url"
    ></video>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import foot from "@/components/foot";
import headd from "@/components/head";
export default {
  data() {
    return {
      mobile_title: "视频播放",
      video_url: "",
      img_url: ""
    };
  },
  components: {
    headd,
    foot
  },
  mounted() {
    this.video_url = this.$route.params.url;
    this.img_url = this.$route.params.img_url;
  }
};
</script>

<style lang="less" scoped>
.video_open {
  width: 100%;
  background-color: #000;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: 0;
  z-index: 2;
  flex-direction: column;
  video {
    max-width: 10rem;
    max-height: 6rem;
    // height: 82vh;
    @media (max-width: 991px) {
          width: 100vw;
         height: 82vh;
    }
  }
}
.head_line {
  border-bottom: 0rem solid #ccc;
  padding-bottom: 0rem;
  width: 100%;
//   position: fixed;
//   top: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/videoplay.vue